import { getQrMfa } from '../../utils/api';
import { decryptData } from '../../utils/encryption';
import { FAILED, LOADING, SUCCESS } from './constants';

export function fetchQrData(tempToken) {
  return async(dispatch) => {
    try {
      dispatch(loadingAction(true));
      const response = await getQrMfa(tempToken);
      const { data } = response;
      const decryptedData = decryptData(data?.qrContent);
      const splitSecret = decryptedData?.split('secret=')?.[1];
      dispatch(
        successAction({
          data: {
            qrContent: data?.qrContent,
            countdown: data?.countdown,
            uri: decryptedData,
            secretCode: splitSecret,
          },
        })
      );
    } catch (error) {
      dispatch(
        failedAction({
          message: error?.data?.message || error.message,
          errorCode: error?.data?.code || error.code,
        })
      );
      dispatch(loadingAction(false));
    }
  };
}

export function failedAction(payload) {
  return { type: FAILED, ...payload };
}

export function loadingAction(isLoading) {
  return { type: LOADING, isLoading };
}

export function successAction(payload) {
  return { type: SUCCESS, ...payload };
}
